'use client';

import { Example } from '@/types/Example';
import ColourBorder from './ColourBorder';
import CommandParagraph from './CommandParagraph';
import ReviewButton from './ReviewButton';
import ShortDescription from './ShortDescription';
import { cn } from '@/lib/utils';

interface ReviewCardProps {
  example: Example;
  className?: string;
}

const ReviewCard = (props: ReviewCardProps) => {
  const { example, className } = props;

  return (
    <div className={cn('flex h-full flex-col justify-between', className)}>
      <div>
        <ColourBorder
          difficulty={example.difficulty}
          variant="horizontal"
          className="mb-4"
        />
        <CommandParagraph command={example.example} />
        <ShortDescription description={example.short_description} />
      </div>
      <ReviewButton cheat={example} className="self-end" />
    </div>
  );
};

export default ReviewCard;
